import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { DialogEditMaintenanceComponent } from 'app/main/maintenances/dialogs/dialog-edit-maintenance/dialog-maintenances.component';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { TabMaintenancesService } from './services/tab-maintenances.service';
var TabMaintenancesComponent = /** @class */ (function () {
    function TabMaintenancesComponent(router, matDialog, maintenancesApi, authenticationService, tabMaintenancesService) {
        this.router = router;
        this.matDialog = matDialog;
        this.maintenancesApi = maintenancesApi;
        this.authenticationService = authenticationService;
        this.tabMaintenancesService = tabMaintenancesService;
        this.cursor = null;
        this.isLoading = true;
        this.hasMoreData = true;
        this.isMaintenanceViewMode = false;
        this.maintenances = [];
        this.loadMore$ = new Subject();
        this.subscription$ = new Subject();
        this.isMaintenanceViewMode = !this.authenticationService.hasPermission('maintenances-edit');
    }
    TabMaintenancesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadMore$.pipe(takeUntil(this.subscription$), tap(function () { return _this.isLoading = true; }), switchMap(function () { return _this.tabMaintenancesService.getEnvironmentMaintenances({
            id: _this.locationEnvironment.id,
            take: 100,
            after: _this.cursor
        }); })).subscribe(function (maintenances) {
            _this.cursor = maintenances.pageInfo.endCursor;
            _this.maintenances = _this.maintenances.concat(maintenances.items);
            _this.hasMoreData = maintenances.pageInfo.startCursor !== maintenances.pageInfo.endCursor;
            _this.isLoading = false;
        });
        this.loadMore$.next();
    };
    TabMaintenancesComponent.prototype.ngOnDestroy = function () {
        this.subscription$.next();
        this.subscription$.complete();
    };
    TabMaintenancesComponent.prototype.toMaintenancesPage = function () {
        var queryParams = {
            locationId_in: this.locationEnvironment.locationSector.location.id,
            sectorId: this.locationEnvironment.locationSector.id,
            environmentId: this.locationEnvironment.id
        };
        this.router.navigate(['/manutencoes'], { queryParams: queryParams });
    };
    TabMaintenancesComponent.prototype.openMaintenanceDialog = function (maintenanceId) {
        var _this = this;
        this.maintenancesApi.searchOne(maintenanceId).subscribe(function (maintenance) {
            _this.matDialog.open(DialogEditMaintenanceComponent, {
                panelClass: 'dialog-edit-maintenance',
                data: {
                    maintenance: maintenance,
                    isViewMode: _this.isMaintenanceViewMode
                }
            });
        });
    };
    TabMaintenancesComponent.prototype.onScroll = function () {
        var _a = this.tabElement.nativeElement, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        var isElementAtBottom = scrollTop + clientHeight === scrollHeight;
        if (isElementAtBottom && !this.isLoading && this.hasMoreData) {
            this.loadMore$.next();
        }
    };
    return TabMaintenancesComponent;
}());
export { TabMaintenancesComponent };
